import React from 'react';
import { ListProduct } from './ListProduct';
import { ListProductWithChildren } from './ListProductWithChildren';
import { IListProductProps } from 'interfaces/listProduct';

interface IProps extends IListProductProps {
  isFirst: boolean;
}

export function ListOptionProduct({ product, onSelected, isFirst }: IProps) {
  const hasChildren = !!product?.children?.length;
  return (
    <>
      {hasChildren && <ListProductWithChildren product={product} onSelected={onSelected} expanded={isFirst} />}
      {!hasChildren && <ListProduct product={product} onSelected={onSelected} />}
    </>
  );
}
